export enum Sections {
  Sort = 'Sort',
  Dates = 'Dates',
  CustomFilters = 'CustomFilters',
  State = 'State',
  Quadrant = 'Quadrant',
  Followed = 'Followed',
  StarredFirst = 'StarredFirst',
}
